import { useMemo } from 'react';

import ReactCountryFlag from 'react-country-flag';

import { Row } from '@tanstack/react-table';

export function useColumns() {
  return useMemo(
    () => [
      {
        accessorKey: 'label',
        header: 'All countries',
        cell: ({ row }: { row: Row<any> }) => {
          return (
            <div className="flex gap-2 items-center">
              <ReactCountryFlag
                className="countryFlag"
                countryCode={row.original.value as string}
                svg
              />
              {row.original.label}
            </div>
          );
        }
      },
      // this is temp is we need to fix the styling issue when only one column is showing
      { accessorKey: 'label2', header: '' }
    ],
    []
  );
}
